import { render } from "./HeaderBloc.vue?vue&type=template&id=3c00325c"
import script from "./HeaderBloc.vue?vue&type=script&lang=js"
export * from "./HeaderBloc.vue?vue&type=script&lang=js"

import "./HeaderBloc.vue?vue&type=style&index=0&id=3c00325c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__